export default {
  authOutdoor: (state) => state.authOutdoor,
  userOutdoor: (state) => state.userOutdoor,
  boxOutdoor: (state) => state.boxOutdoor,

  globalLoadingOutdoor: (state) => state.globalLoadingOutdoor,
  i18nDataOutdoor: (state) => state.i18nDataOutdoor,
};
